<mat-sidenav-container class="sidenav-container">
  <mat-sidenav #drawer mode="over" [opened]="false" class="custom-sidenav">
    <mat-nav-list>
      @if (isUserVerified) {
        <div
          class="drawer-header"
          (click)="router.navigate(['profileSettings']); drawer.close()"
        >
          <div class="avatar-container">
            @if (userAvatarUrl) {
              <img [src]="userAvatarUrl" alt="Avatar" class="user-avatar" />
            } @else {
              <mat-icon class="default-avatar">account_circle</mat-icon>
            }
          </div>
          <div class="user-details">
            <span class="full-name">{{ userFullName }}</span>
            <span class="view-profile">{{ 'View Profile' | translate }}</span>
          </div>
        </div>
      }

      <a mat-list-item routerLink="/" (click)="drawer.close()">
        <mat-icon>home</mat-icon>
        <span>{{ 'Home' | translate }}</span>
      </a>

      @if (clubsService.theme()?.show_achievements) {
        <a mat-list-item routerLink="/achievements" (click)="drawer.close()">
          <mat-icon>emoji_events</mat-icon>
          <span>{{ 'Achievements' | translate }}</span>
        </a>
      }
      <!-- Leaderboard: gated by both flags. `show_leaderboard !== false`
           treats NULL/missing column as "on" (backward compat for clubs
           that pre-date the column). Same semantics as the route guard. -->
      @if (clubsService.flags()?.points_enabled && clubsService.theme()?.show_leaderboard !== false) {
        <a mat-list-item routerLink="/leaderboard" (click)="drawer.close()">
          <mat-icon>military_tech</mat-icon>
          <span>{{ 'Leaderboard' | translate }}</span>
        </a>
      }
      @if (isUserVerified) {
        @if (clubsService.theme()?.show_calendar !== false) {
          <a mat-list-item routerLink="/my-reservations" (click)="drawer.close()">
            <mat-icon>event_note</mat-icon>
            <span>{{ 'My reservations' | translate }}</span>
          </a>
          <a
            mat-list-item
            (click)="router.navigate(['calendar']); drawer.close()"
          >
            <mat-icon>calendar_today</mat-icon>
            <span>{{ 'Calendar' | translate }}</span>
          </a>
        }
        @if (clubsService.flags()?.actively_link) {
          <a mat-list-item routerLink="/player-preferences" (click)="drawer.close()">
            <mat-icon>tune</mat-icon>
            <span>{{ 'Player Preferences' | translate }}</span>
            <span class="red-chip">NEW</span>
          </a>
        }

        @if (clubsService.flags()?.workouts) {
          <a mat-list-item routerLink="/workouts" (click)="drawer.close()">
            <mat-icon>fitness_center</mat-icon>
            <span>{{ 'My Workout' | translate }}</span>
          </a>
        }

        @if (clubsService.flags()?.diets && memberDiet.hasActivePlan()) {
          <a mat-list-item routerLink="/my-diet-plan" (click)="drawer.close()">
            <mat-icon>restaurant</mat-icon>
            <span>{{ 'My diet plan' | translate }}</span>
          </a>
        }

        @if (clubsService.theme()?.show_events_tab) {
          <a mat-list-item routerLink="/tournaments" (click)="drawer.close()">
            <mat-icon>
              <img width="24" height="24" src="assets/icons/tournament.svg" />
            </mat-icon>

            <span>{{ 'Events' | translate }}</span>
          </a>
        }

        @if (hasDiscounts) {
          <a mat-list-item routerLink="/discounts" (click)="drawer.close()">
            <mat-icon>local_offer</mat-icon>
            <span>{{ 'Discounts' | translate }}</span>
          </a>
        }

        @if (clubsService.flags()?.stripe_connect && clubsService.flags()?.subscriptions) {
          <a mat-list-item routerLink="/membership" (click)="drawer.close()">
            <mat-icon>card_membership</mat-icon>
            <span>{{ 'Membership Plans' | translate }}</span>
          </a>
        }

        @if (clubsService.flags()?.verification_documents && clubsService.flags()?.verification_documents_required) {
          <a
            mat-list-item
            routerLink="/verification-documents"
            (click)="drawer.close()"
          >
            <mat-icon>verified_user</mat-icon>
            <span>{{ 'vd_my_title' | translate }}</span>
          </a>
        }
      }

      @if (clubsService.theme()?.rules) {
        <a mat-list-item routerLink="/club-rules" (click)="drawer.close()">
          <mat-icon>gavel</mat-icon>
          <span>{{ 'Club Rules' | translate }}</span>
        </a>
      }

      @if (isUserAdmin) {
        @if (clubsService.flags()?.diets) {
          <a mat-list-item routerLink="/settings/diets" (click)="drawer.close()">
            <mat-icon>restaurant</mat-icon>
            <span>{{ 'Diets' | translate }}</span>
          </a>
        }
        <a mat-list-item routerLink="/settings" (click)="drawer.close()">
          <mat-icon>speed</mat-icon>
          <span>{{ 'Admin Panel' | translate }}</span>
        </a>
      } @else if (permissionsService.visibleModuleKeys().size > 0) {
        <!-- Non-admin coaches/staff who have been granted at least one
             module permission still need a way to reach /settings. The
             child routes' modulePermissionGuard filters which pages they
             actually see — the link only opens the shell. -->
        <a mat-list-item routerLink="/settings" (click)="drawer.close()">
          <mat-icon>speed</mat-icon>
          <span>{{ 'Admin Panel' | translate }}</span>
        </a>
      }
      <a
        mat-list-item
        (click)="switchLanguage(lang === 'en' ? 'gr' : 'en'); drawer.close()"
      >
        <mat-icon>language</mat-icon>
        <span>{{ lang === 'en' ? 'Ελληνικά' : 'English' }}</span>
      </a>
    </mat-nav-list>
    <mat-nav-list>
      <a mat-list-item (click)="openReportDialog()">
        <mat-icon>bug_report</mat-icon>
        <span>{{ 'Report a problem' | translate }}</span>
      </a>
      <a
        mat-list-item
        (click)="themingService.toggleTheme(); drawer.close()"
      >
        <mat-icon>dark_mode</mat-icon>
        <span>{{ 'Toggle theme' | translate }}</span>
      </a>
      <a mat-list-item routerLink="/terms" (click)="drawer.close()">
        <mat-icon>description</mat-icon>
        <span>{{ 'terms_title' | translate }}</span>
      </a>
      <a mat-list-item routerLink="/privacy" (click)="drawer.close()">
        <mat-icon>privacy_tip</mat-icon>
        <span>{{ 'privacy_title' | translate }}</span>
      </a>
    </mat-nav-list>
  </mat-sidenav>

  <mat-sidenav-content>
    <ng-content></ng-content>
  </mat-sidenav-content>
</mat-sidenav-container>
